import React from 'react'
import { Link } from 'react-router-dom'
import { CONTACT_INFO, SITE_LINKS, SOCIAL_LINKS } from '../constants/siteLinks'
import { SERVICE_PAGES, servicePath } from '../constants/servicePages'

const QUICK_LINKS = [
  { label: 'Home', to: SITE_LINKS.home },
  { label: 'Shop', to: SITE_LINKS.shop },
  { label: 'Our Services', href: '/#services' },
  { label: 'Contact Us', href: SITE_LINKS.contact },
]

const SUPPORT_LINKS = [
  { label: 'Get a Quote', href: SITE_LINKS.contact },
  { label: 'Technical Support', href: CONTACT_INFO.phoneHref },
  { label: 'Email Support', href: CONTACT_INFO.emailHref },
  { label: 'Visit Our Office', href: CONTACT_INFO.mapsHref, external: true },
]

const SOCIALS = SOCIAL_LINKS

/** Site footer: brand, quick links, service pages, support and contact columns. */
function HomeFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="hf">
      <div className="hf__container">
        <div className="hf__grid">
          <div className="hf__brand">
            <Link to={SITE_LINKS.home} aria-label="Fabritech home">
              <img src="/assets/img/logo/F_logo.png" alt="Fabritech" />
            </Link>
            <p>
              Fabritech delivers Starlink internet, digital security, networking, power backup, software and training
              for homes, businesses and institutions across Rwanda.
            </p>
            <div className="hf__socials">
              {SOCIALS.map((social) => (
                <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label}>
                  <i className={`fa-brands ${social.icon}`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <nav className="hf__col" aria-label="Quick links">
            <h3>Quick Links</h3>
            <ul>
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link to={link.to} className="hf__link">
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} className="hf__link">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <nav className="hf__col" aria-label="Our services">
            <h3>Our Services</h3>
            <ul>
              {SERVICE_PAGES.map((service) => (
                <li key={service.slug}>
                  <Link to={servicePath(service.slug)} className="hf__link">
                    {service.menuLabel}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="hf__col" aria-label="Support">
            <h3>Support</h3>
            <ul>
              {SUPPORT_LINKS.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="hf__link" {...(link.external ? { target: '_blank', rel: 'noreferrer' } : {})}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="hf__col">
            <h3>Contact Information</h3>
            <ul className="hf__contact">
              <li>
                <i className="fa-solid fa-location-dot" aria-hidden="true" />
                <a href={CONTACT_INFO.mapsHref} target="_blank" rel="noreferrer" className="hf__link">
                  {CONTACT_INFO.address}, Kigali
                </a>
              </li>
              <li>
                <i className="fa-solid fa-envelope" aria-hidden="true" />
                <a href={CONTACT_INFO.emailHref} className="hf__link">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li>
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <a href={CONTACT_INFO.phoneHref} className="hf__link">
                  {CONTACT_INFO.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hf__bottom">
          <p>© {year} Fabritech. All rights reserved.</p>
          <p>
            Developed by <span>Maliki NTWALI</span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default HomeFooter
